import pages from "./en-US/pages";

export default {
  "navBar.lang": "Languages",
  ...pages,
};
